import{slice}from"../data/slice.js";import{toSignatureHash}from"./toSignatureHash.js";export const toFunctionSelector=fn=>slice(toSignatureHash(fn),0,4);